/* eslint-disable import/prefer-default-export */
/* eslint-disable import/exports-last */

type Rotate3dTransform = [number, number, number]

export function mapRange(value: number, x1: number, y1: number, x2: number, y2: number) {
  return ((value - x1) * (y2 - x2)) / (y1 - x1) + x2
}

export function rotate(degree: number, amount: number) {
  const result = degree + amount
  return result > 360 ? result - 360 : result
}

export function coinFlip() {
  return Math.random() > 0.5
}

// avoid this for circles, as it will have no visual effect
const zAxisRotation: Rotate3dTransform = [0, 0, 1]

export const rotationTransforms = [
  // dual axis rotations (a bit more realistic)
  [1, 1, 0],
  [1, 0, 1],
  [0, 1, 1],
  // single axis rotations (a bit dumber)
  [1, 0, 0],
  [0, 1, 0],
  zAxisRotation,
] as Rotate3dTransform[]

export function isCircleZAxisRotation([x1, y1, z1]: Rotate3dTransform) {
  const [x, y, z] = zAxisRotation
  return x === x1 && y === y1 && z === z1
}

export function shouldBeCircle(rotationIndex: number) {
  return !!rotationTransforms[rotationIndex] && !isCircleZAxisRotation(rotationTransforms[rotationIndex]) && coinFlip()
}

export function animationRound(num: number, precision = 4) {
  const mul = Math.pow(10, precision)

  return Math.round(num * mul) / mul
}

export function degreeToLabel(degree: number) {
  return animationRound(degree, 2).toString().replace('.', '-')
}
